import { theme, Types } from '@fiverr-private/theme';
import { formsTokenColors } from '../shared/formsTokenColors';
import { SizeType } from './types';

const KNOB_SIZE_SMALL = 20;
const TOGGLE_WIDTH_SMALL = KNOB_SIZE_SMALL + 20;
const KNOB_SIZE = 28;
const TOGGLE_WIDTH = KNOB_SIZE + 24;
const SPACING_UNIT = 4;
export const SWINGER_MARGIN = '0.5';

export const getValidationColor = ({
    isError,
    isSuccess,
    disabled,
}: {
    isError: boolean;
    isSuccess: boolean;
    disabled: boolean;
}): {
    color: Types.TypographyColor;
    outlineColor: Types.Color;
} => {
    const { validationError, validationSuccess } = theme.semanticBorderColors;

    if (isError) {
        return {
            color: validationError,
            outlineColor: validationError,
        };
    } else if (isSuccess) {
        return {
            color: validationSuccess,
            outlineColor: validationSuccess,
        };
    } else if (disabled) {
        return {
            color: formsTokenColors.disabledColor,
            outlineColor: 'transparent',
        };
    } else {
        return {
            color: formsTokenColors.color,
            outlineColor: 'transparent',
        };
    }
};

export const getStylingProps = (size: SizeType) => {
    const sizeMap: Record<
        SizeType,
        {
            switcherStylingProps: Types.Box;
            togglerStylingProps: Types.ContainerProps;
            swingerStylingProps: Types.ContainerProps;
        }
    > = {
        sm: {
            switcherStylingProps: {
                lineHeight: 'b_sm',
            },
            togglerStylingProps: {
                height: KNOB_SIZE_SMALL + 4,
                width: TOGGLE_WIDTH_SMALL,
            },
            swingerStylingProps: {
                height: KNOB_SIZE_SMALL,
                width: KNOB_SIZE_SMALL,
                left: TOGGLE_WIDTH_SMALL - KNOB_SIZE_SMALL - Number(SWINGER_MARGIN) * SPACING_UNIT * 2,
            },
        },
        md: {
            switcherStylingProps: {
                lineHeight: 'b_xxl',
            },
            togglerStylingProps: {
                height: KNOB_SIZE + 4,
                width: KNOB_SIZE + 24,
            },
            swingerStylingProps: {
                height: KNOB_SIZE,
                width: KNOB_SIZE,
                left: TOGGLE_WIDTH - KNOB_SIZE - Number(SWINGER_MARGIN) * SPACING_UNIT * 2,
            },
        },
    };
    return sizeMap[size] || {};
};
